import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    beneficiaryRoleDescription:
      'A beneficial owner must occupy one of the roles listed below:',
    beneficiaryRoleTitle: 'Role within the company',
    create: {
      invalidBeneficiary:
        'This is probably not a beneficial owner. Please check the information or go back.',
    },
    directorAndShareholderLabel: {
      title: 'Director and shareholder',
    },
    directorLabel: {
      description:
        'The beneficial owner legally represents the company or has a mandate as president or manager.',
      title: 'Director',
    },
    edit: {
      invalidBeneficiary:
        'This is probably not a beneficial owner. Please check the information or delete the beneficial owner.',
    },
    emailAlreadyExists:
      'This e-mail address is already used by one of the beneficial owners',
    emailLabel: 'E-mail of the beneficial owner',
    firstNameLabel: 'First Name',
    genderLabel: 'Gender',
    helpLink: 'Contact us',
    helpPrompt: 'Is the beneficial owner under 18?',
    lastNameLabel: 'Last Name',
    no: 'No',
    personalInformationTitle: 'Personal Information',
    shareholderLabel: {
      description:
        'The beneficial owner owns 25% or more of the company’s capital, directly or indirectly.',
      title: 'Shareholder',
    },
    validBeneficiary:
      'He/She will receive an email notification to send us a **proof of identity**. This document is **required** to open your pro Shine account.',
    yes: 'Yes',
  },
  fr: {
    beneficiaryRoleDescription:
      'Un bénéficiaire effectif doit obligatoirement occuper un des rôles listés ci-dessous :',
    beneficiaryRoleTitle: 'Rôle au sein de l’entreprise',
    create: {
      invalidBeneficiary:
        "Il ne s'agit probablement pas d'un bénéficiaire effectif. Veuillez vérifier les informations ou revenir en arrière.",
    },
    directorAndShareholderLabel: {
      title: 'Dirigeant·e et actionnaire',
    },
    directorLabel: {
      description:
        "Le bénéficiaire effectif représente légalement l’entreprise ou dispose d'un mandat de président·e ou de gérant·e.",
      title: 'Dirigeant·e',
    },
    edit: {
      invalidBeneficiary:
        "Il ne s'agit probablement pas d'un bénéficiaire effectif. Veuillez vérifier les informations ou supprimer le bénéficiaire effectif.",
    },
    emailAlreadyExists:
      "Cette adresse e-mail est déjà utilisée par l'un des bénéficiaires effectifs",
    emailLabel: 'E-mail du bénéficiaire effectif',
    firstNameLabel: 'Prénom',
    genderLabel: 'Civilité',
    helpLink: 'Contactez-nous',
    helpPrompt: 'Le bénéficiaire effectif a moins de 18 ans ?',
    lastNameLabel: 'Nom',
    no: 'Non',
    personalInformationTitle: 'Informations personnelles',
    shareholderLabel: {
      description:
        'Le bénéficiaire effectif possède 25 % ou plus du capital de l’entreprise, directement ou indirectement.',
      title: 'Actionnaire',
    },
    validBeneficiary:
      'Il·Elle recevra une notification par email pour nous transmettre un **justificatif d’identité**. Ce document est **obligatoire** pour ouvrir votre compte pro Shine.',
    yes: 'Oui',
  },
} as const);
